export default {
    public: '/public',
    applicationData: '/public/applicationData',
    pages: {
        home: '/public/home',
        franchise: '/public/franchise',
        product: '/public/produit',
        menu: '/public/menu',
        storeLocator: '/public/store-locator',
        catalog: '/public/carte',
        faq: '/public/faq',
        notFound: '/public/404',
        family: '/public/family',
        custom: '/public/custom-pages',
        customItems: '/public/custom-pages/menu-items',
        timeline: '/public/timeline',
        delivery: '/public/delivery',
        navMenu: '/public/nav-menu',
        operation: {
            fetch: '/public/operation-device/coupons',
            root: '/public/operation-device',
            all: '/public/operation-device/all',
            democraticBurger: {
                fetch: '/public/operation-device/democratic-burger/coupons',
                drive: '/public/operation-device/democratic-burger/drive',
                wallet: '/public/operation-device/democratic-burger/wallet',
                election: '/public/democratic-burger/election'
            },
            confirmChoice: ({
                operationCode,
                couponCode,
                promotionId
            }: {
                operationCode: string,
                couponCode: string,
                promotionId: string
            }) =>
                `/public/operation-device/${operationCode}/confirm-choice?couponCode=${couponCode}&promotionId=${promotionId}`,
            getRandomCoupon: ({ operationCode }: { operationCode: string }) =>
                `/public/operation-device/${operationCode}/confirm-get-random`
        },
        restaurant: {
            fetch: '/public/restaurant',
            coupons: '/public/operation-device/local',
            wallet: '/public/operation-device'
        },
        birthday: {
            page: '/public/birthday',
            openings: '/public/birthday/openings'
        }
    },
    storeLocator: {
        markers: '/public/store-locator/markers',
        search: '/public/store-locator/search',
        all: '/public/restaurant/all',
        static: '/static/restaurants.json'
    },
    directions: 'https://www.google.com/maps/dir/?api=1',
    faq: {
        formData: '/public/faq/form',
        send: '/public/faq'
    },
    newsletter: '/public/newsletter',
    app: {
        init: '/public/app/initialize',
        notation: '/public/app/notation',
        settings: '/public/app/settings',
        homepage: '/public/homepage',
        playIntegrity: '/public/device-check/play-integrity/unique-value'
    },
    orb: {
        follow: '/public/orb/follow',
        unfollow: '/public/orb/unfollow',
        all: '/public/orb/status/@all',
        last: '/public/orb/status/@last'
    },
    kingdom: {
        auth: {
            loginWithSocial: '/public/kingdom/auth/login-with-social',
            loginWithMFA: '/public/kingdom/auth/login-with-mfa',
            sendOtp: '/public/kingdom/auth/send-otp',
            verifyOtp: '/public/kingdom/auth/verify-otp'
        },
        dashboard: '/kingdom',
        signup: '/public/kingdom/signup',
        signin: '/public/kingdom/login',
        activate: '/public/kingdom/activate/send',
        congratulations: '/public/kingdom/activate',
        profile: {
            user: '/kingdom/profile',
            touchid: '/kingdom/profile/user/touchid',
            optins: '/kingdom/profile/optins',
            update: '/kingdom/profile/user',
            kid: '/kingdom/profile/kids',
            restaurant: '/kingdom/profile/restaurants',
            creditCard: '/kingdom/profile/credit-cards',
            creditCardV2: '/kingdom/profile/credit-cards-v2',
            logout: '/kingdom/logout',
            student: {
                choices: '/kingdom/profile/student/choices',
                deactivate:
                    '/kingdom/blazons/national-student-blason/_deactivate'
            }
        },
        blazons: '/kingdom/blazons',
        privileges: {
            page: '/kingdom/offers',
            wallet: '/kingdom/offers/wallet'
        },
        email: {
            update: '/kingdom/email/change',
            activate: '/public/kingdom/activate/email'
        },
        password: {
            mail: '/public/kingdom/password/reset/send',
            reset: '/public/kingdom/password/reset',
            update: '/kingdom/password/change'
        },
        card: {
            page: '/kingdom/card',
            wallet: '/kingdom/card/wallet'
        },
        points: {
            page: '/kingdom/points',
            renew: '/kingdom/points/renew',
            transform: '/kingdom/points/transform',
            untransform: '/kingdom/points/untransform',
            donation: '/kingdom/points/donation',
            donationHistory: '/kingdom/points/donation/history',
            donationAccept: '/kingdom/points/donation/accept'
        },
        lottery: {
            pagePublic: '/public/lottery/available',
            page: '/kingdom/lottery/available',
            gain: '/kingdom/lottery'
        },
        scratch: {
            pagePublic: '/public/scratch/available',
            page: '/kingdom/scratch/available',
            play: '/kingdom/scratch',
            finalize: '/kingdom/scratch/finalize'
        },
        analyticsData: '/kingdom/analyticsData',
        order: {
            receipt: '/kingdom/order/receipt/'
        }
    },
    features: '/public/features',
    ecommerce: {
        catalog: ({
            restaurantId,
            isDelivery,
            catalogName
        }: {
            restaurantId: string,
            isDelivery: boolean,
            catalogName?: string | typeof undefined
        }) => {
            if (isDelivery) {
                return `/catalog-delivery/catalog-delivery.${restaurantId}.json`
            }
            return `/catalog/${catalogName || 'catalog'}.${restaurantId}.json`
        },
        coupons: '/public/orders/coupon-code',
        errors: '/public/orders/errors',
        lastOrder: '/public/orders/last',
        nepting: '/public/nepting/badstatus',
        orders: '/public/orders',
        addCoupon: 'public/orders/add-coupon',
        removeCoupon: 'public/orders/remove-coupon',
        // TODOBEN : vérifier que cette route fonctionne sans LogIn
        parkingOpen: '/public/orders/parking-open',
        priceEdge: '/public/orders/price-edge',
        tableServiceAvailable: '/public/orders/table-service-available',
        adyenPaymentMethods: '/public/orders/v2/payment-methods'
    },
    satisfaction: '/public/satisfaction',
    futureWhopper: {
        form: '/public/future-whopper',
        get: '/public/future-whopper/get'
    },
    veggieKing: {
        form: '/public/veggie-king',
        get: '/public/veggie-king/get'
    },
    deals: {
        get: '/public/offers/page'
    },
    coupons: {
        winningForm: {
            send: '/public/offers/winning-form',
            formAvailability: '/public/offers/winning-form/availability'
        }
    },
    tuPreferesKing: {
        pageData: '/public/tu-preferes-king',
        duel: '/public/tu-preferes-king/',
        choice: '/public/tu-preferes-king/choice',
        collect: '/public/tu-preferes-king/collect',
        goodies: 'public/tu-preferes-king/goodies',
        goodiesAvailability: 'public/tu-preferes-king/availability'
    },
    optinPush: '/public/device/optin',
    complaint: {
        get: (token: string) => `/public/complaint?token=${token}`,
        postMessage: `/public/complaint/messages`
    }
}
